var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',{staticClass:"ma2 ma3-ns"},[_c('OpenImagesBrowser',{attrs:{"items":_vm.items,"touchMode":_vm.touchMode,"sortFields":_vm.sortFields,"displayFields":_vm.displayFields,"filterFields":_vm.filterFields,"colors":_vm.colors}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }